<template>
  <div class="element-button element-round-button" :class="{ loading }">
    <div class="body"><slot /></div>
    <div class="loading"><i class="fa fa-spinner fa-spin"></i></div>
  </div>
</template>
<script>
export default {
  props: [ "loading" ]
}
</script>
